import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicantIndividualMessage } from '@app/models/recruiting/applicant-individual-message.model';
import { JobFunnelMessageTemplate } from '@models/recruiting/job-funnel-message-template.model';

@Injectable()
export class ApplicantIndividualMessageService {
    constructor(private http: HttpClient) {}

    async resendMessage(applicantIndividualMessage: ApplicantIndividualMessage): Promise<void> {
        const url = `/v2/applicantTracker/applicantIndividualMessages/${applicantIndividualMessage.id}/retry`;
        await this.http.post(url, null, { observe: 'response' }).toPromise();
    }

    async sendApplicantIndividualMessage(
        applicantId: number,
        jobFunnelMessageTemplate: JobFunnelMessageTemplate
    ): Promise<void> {
        const applicantIndividualMessage = new ApplicantIndividualMessage({
            atsApplicantId: applicantId,
            isBulk: false,
            replyTo: jobFunnelMessageTemplate.replyTo,
            subject: jobFunnelMessageTemplate.subject,
            body: jobFunnelMessageTemplate.body,
        });

        await applicantIndividualMessage.save();
    }
}
